var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v(_vm._s(_vm.config.header))]),_c('div',{style:(`width: ${_vm.config.width}; height: ${_vm.config.height};`),attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }